/*===================================================================
=       SPENDING STATUS CONVERTER                       =
====================================================================*/
/**
 *
 */


import { SpendingDemandStatus } from "../types/spending.types";

export const spendingDemandStatusRAWtoIconText = (
  statusRaw: SpendingDemandStatus
): any => {
  switch (statusRaw) {
    case "REFUSED":
      return "error";
    case "VALIDATE":
      return "valided";
    case "WAITING_UPDATE":
      return "invalid";
    case "WAITING_VALIDATION":
      return "pending";
    default:
      return null;
  }
};

export interface ReadableStatus {
  status: string;
  color: {
    light: string;
    normal: string;
    dark: string;
  };
}
export const spedingStatusRawToReadableStatus = (
  statusRaw: string
) : ReadableStatus=> {
  switch (statusRaw) {
    case "REFUSED":
      return {
        status: "Refusé",
        color: {
          light: "#F0C5C5",
          normal: "#F0C5C5",
          dark: "#6E4444",
        },
      };
    case "VALIDATE":
      return {
        status: "Validé",
        color: {
          light: "#D0F0C5",
          normal: "#D0F0C5",
          dark: "#4F6E44",
        },
      };
    case "WAITING_UPDATE":
      return{
        status: "À corriger",
        color: {
          light: "#F0C5C5",
          normal: "#F0C5C5",
          dark: "#6E4444",
        },
      }
      
    case "WAITING_VALIDATION":
      return  {
        status: "En Attente",
        color: {
          light: "#FFF7D9",
          normal: "#FFF7D9",
          dark: "#6E5B44",
        }
    };
    default:
      return {
        status: statusRaw,
        color: {
          light: "#EDF0F1",
          normal: "#EDF0F1",
          dark: "#000000",
        },
      };
  }
};


